export default __webpack_public_path__ + "static/media/logo-moblie.91e7ebd0.svg";